import axios from "axios";

export default {
  methods: {
    sendFeedbackMail(params) {
      return axios.post("/send-feedback-mail", params);
    },
  },
};
